import { gql } from "@apollo/client";

export const QUESTIONNAIRE_MUTATION = gql`
  mutation fillQuestionnaire(
    $email: String
    $name: String
    $dateOfBirth: Date
    $mailing: Boolean!
  ) {
    fillQuestionnaire(
      input: { email: $email, name: $name, dateOfBirth: $dateOfBirth, mailing: $mailing }
    )
  }
`;
